/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Readiness_IdleInputs */

const en_us2_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No workout in progress. Start whenever you like.`)
};

const pt_br2_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino em andamento. Comece quando quiser.`)
};

const es_419_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ningún entrenamiento en curso. Empieza cuando quieras.`)
};

const pt_pt2_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum treino a decorrer. Começa quando quiseres.`)
};

const fr_fr2_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune séance en cours. Commence quand tu veux.`)
};

const de_de2_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Training läuft. Fang an, wann du willst.`)
};

const it_it2_workout_readiness_idle = /** @type {(inputs: Workout_Readiness_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun allenamento in corso. Inizia quando vuoi.`)
};

/**
* | output |
* | --- |
* | "No workout in progress. Start whenever you like." |
*
* @param {Workout_Readiness_IdleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_idle = /** @type {((inputs?: Workout_Readiness_IdleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_IdleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_idle(inputs)
	if (locale === "es-419") return es_419_workout_readiness_idle(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_idle(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_idle(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_idle(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_idle(inputs)
	return en_us2_workout_readiness_idle(inputs)
});
export { workout_readiness_idle as "workout.readiness_idle" }